module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Bold.645de9a56e29ebb0982c8b6b4ef015a0.woff2";